import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/reportes/ingresosYGastos';
import IngresosYGastos from './IngresosYGastos';


const ms2p = (state) => {
    return {
        ...state.ingresosYGastos,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(IngresosYGastos);
